import React from 'react';

const BankingServices = () => {
  return (
    <div className="page-content">
      <section className="hero-small">
        <div className="container">
          <h1>Banking & Financial Services</h1>
          <p>Innovative technology solutions for the financial sector.</p>
        </div>
      </section>
      
      <section className="services-detail">
        <div className="container">
          <div className="service-grid">
            <div className="service-card">
              <h3>Digital Banking</h3>
              <p>Modern banking platforms and mobile solutions</p>
            </div>
            <div className="service-card">
              <h3>Risk Management</h3>
              <p>Advanced analytics for risk assessment and compliance</p>
            </div>
            <div className="service-card">
              <h3>Payment Solutions</h3>
              <p>Secure and scalable payment processing systems</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default BankingServices;